import { Grid, Paper, Typography, Box } from '@mui/material'
import {
  TrendingUp,
  AttachMoney,
  LocalOffer,
  AccountBalanceWallet
} from '@mui/icons-material'
import KPICard from '../analytics/KPICard'
import { FinancialSummary } from '../../services/financialService'

interface FinancialDashboardProps {
  data: FinancialSummary | null
  loading?: boolean
}

export default function FinancialDashboard({ data, loading = false }: FinancialDashboardProps) {
  if (!data && !loading) {
    return null
  }

  return (
    <Grid container spacing={3}>
      <Grid item xs={12} sm={6} md={3}>
        <KPICard
          title="إجمالي الإيرادات"
          value={data ? `$${data.totalRevenue.toFixed(2)}` : '...'}
          icon={<AttachMoney />}
          color="#4CAF50"
          loading={loading}
        />
      </Grid>
      <Grid item xs={12} sm={6} md={3}>
        <KPICard
          title="إجمالي العمولات"
          value={data ? `$${data.totalCommissions.toFixed(2)}` : '...'}
          icon={<TrendingUp />}
          color="#2196F3"
          loading={loading}
        />
      </Grid>
      <Grid item xs={12} sm={6} md={3}>
        <KPICard
          title="إجمالي الخصومات"
          value={data ? `$${data.totalDiscounts.toFixed(2)}` : '...'}
          icon={<LocalOffer />}
          color="#FF9800"
          loading={loading}
        />
      </Grid>
      <Grid item xs={12} sm={6} md={3}>
        <KPICard
          title="صافي الربح"
          value={data ? `$${data.netProfit.toFixed(2)}` : '...'}
          icon={<AccountBalanceWallet />}
          color="#FF6600"
          loading={loading}
        />
      </Grid>
    </Grid>
  )
}

